var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('admin-header',{attrs:{"title":'Financial Profiles',"uploader":true},on:{"open-filter":_vm.openFilter,"entity-quick-search":_vm.search,"create-entity-request":_vm.goToNewEntityScreen,"csv-upload":_vm.multiSave}}),_vm._v(" "),_c('div',{attrs:{"id":"admin-content"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14097998","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/FinancialProfile/AdminFinancialProfile.vue
// module id = 1886
// module chunks = 1